import { Unit } from '../../common';
import { ProductLine } from '../../product-line/product-line';

export interface GetProjectItemsResponse {
  count: number;
  items: {
    projectItemId: number,
    projectItemCode: string,
    product: {
      productId: number,
      productCode: string,
      productDesc: string,
      productLine: ProductLine,
    }[],
    unit: Unit,
  };
}
